<template>
  <div class="videoPage">
    <div v-if="access_token">
      <div>
        <app-side-bar-v2 />
      </div>
      <div
        style="min-width: calc(100% - 17rem); flex-grow: 1; flex-basis: auto"
      >
        <app-nav-bar-v2 />
      </div>
    </div>
    <div v-else>
      <navbarv2 />
    </div>
    <div class="videoPageMain">
      <div :class="access_token ? 'login-usr' : 'without-login'">
        <div class="top-head">Videos</div>
        <div class="video-outer-sec">
          <div class="video-inner-sec">
            <div
            v-for="(data, index) in videoDetailsArray"
            :key="index"
            class="img-div"
            >
              <div class="play-btn-sec">
                <img
                  src="../../assets/images/videoPageImgs/play-button.png"
                  @click="startVideo(data.uTubeLink)"
                  alt=""
                />
              </div>
              <img :src="data.img" alt="" class="main-img" />
              <p class="video-title">
                {{ data.title }}
              </p>
            </div>
          </div>
        </div>

        <div class="videoPopup">
          <el-dialog
            :visible.sync="videoDialogVisible"
            width="80%"
            @closed="handleClose"
          >
            <iframe
              width="100%"
              height="580px"
              :src="current_video"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppSideBarV2 from "../../components/admin/appSideBarV2/appSideBarV2";
import AppNavBarV2 from "../../components/admin/appNavBarV2/AppNavBarV2";
export default {
  name: "VideoPage",
  components: {
    AppSideBarV2,
    AppNavBarV2,
  },
  mixins: [],
  data() {
    return {
      videoDialogVisible: false,
      videoDetailsArray: [
        // {
        //   title: "Edit Store Time",
        //   img: require("@/assets/images/videoPageImgs/NymbleUp - Edit store time.png"),
        //   uTubeLink: "https://www.youtube.com/embed/gK7PH_p0ai0",
        // },
        {
          title: "Shift Preferences",
          img: require("@/assets/images/videoPageImgs/NymbleUp-Manage Shift Preferences.png"),
          uTubeLink: "https://www.youtube.com/embed/KDKDtPuKW1U",
        },
        {
          title: "Edit Shifts",
          img: require("@/assets/images/videoPageImgs/NymbleUp-Bulk Shifts.png"),
          uTubeLink: "https://www.youtube.com/embed/cRrXU361r4Y",
        },
        {
          title: "Weekly Off",
          img: require("@/assets/images/videoPageImgs/NymbleUp-Weekly Off.png"),
          uTubeLink: "https://www.youtube.com/embed/3mFfayp9ofo",
        },
        {
          title: "Edit Projected Transactions",
          img: require("@/assets/images/videoPageImgs/NymbleUp-Edit Projected Transactions.png"),
          uTubeLink: "https://www.youtube.com/embed/0d0XpU5GssI",
        },
        {
          title: "Edit store and section timings",
          img: require("@/assets/images/videoPageImgs/store setting overview.png"),
          uTubeLink: "https://www.youtube.com/embed/szdm56gR-pc",
        },
      ],
      current_video: "",
      access_token: false,
    };
  },
  computed:{
   isMCD(){
    let localData = JSON.parse(localStorage.getItem('check_company'));
    return localData.is_mcd;
   },
   isMcdNorth(){
    let localData = JSON.parse(localStorage.getItem('check_company'));
    return localData.is_mcd_north;
   },
   checkCompany(){
    return JSON.parse(localStorage.getItem('check_company'));
   },
  },
  created() {
    if (localStorage.getItem("x-access-token")) {
      this.access_token = true;
    }
  },
  mounted(){
    document.getElementById("app").style.marginLeft = "80px";
    let store_settings =  {
            title: "Store Settings",
            img: require("@/assets/images/videoPageImgs/store_timing.jpg"),
            uTubeLink: "https://www.youtube.com/embed/k1NS2Bt4TLo",
          }
    if(this.checkCompany.is_sb_malaysia){
      this.videoDetailsArray.push(
        {
          title: "Cluster Management",
          img: require("@/assets/images/videoPageImgs/cluster_mng2.png"),
          uTubeLink: "https://www.youtube.com/embed/cF1BTVWKeQ0",
        },
        {
          title: "Monthly Schedule",
          img: require("@/assets/images/videoPageImgs/monthly_schedule.png"),
          uTubeLink: "https://www.youtube.com/embed/s2FjMgnQgEY",
        },
        {
          title: "Create Edit Cluster",
          img: require("@/assets/images/videoPageImgs/cluster.png"),
          uTubeLink: "https://www.youtube.com/embed/dP0rn5KDlDI",
        }
      );
    }
    if(this.isMCD|| this.isMcdNorth){
      this.videoDetailsArray = [
        {
          title: "Monthly Add Shifts",
          img: require("@/assets/images/videoPageImgs/Monthly Add Shift.png"),
          uTubeLink: "https://www.youtube.com/embed/0pn9m0BBk9Q",
        },
        {
          title: "Monthly Scheduler",
          img: require("@/assets/images/videoPageImgs/Monthly Scheduler.png"),
          uTubeLink: "https://www.youtube.com/embed/kk9w52WiSK8",
        },
        {
          title: "NymbleUp Order Type",
          img: require("@/assets/images/videoPageImgs/Nymbleup Order Type.png"),
          uTubeLink: "https://www.youtube.com/embed/zWHsUcp5dzY",
        },
        {
          title: "Store Settings",
          img: require("@/assets/images/videoPageImgs/Team Settings.png"),
          uTubeLink: "https://www.youtube.com/embed/xj1U5SEeeos",
        },
        {
          title: "Store Settings Overview",
          img: require("@/assets/images/videoPageImgs/store setting overview.png"),
          uTubeLink: "https://www.youtube.com/embed/i0gSVx3K8yA",
        },
        {
          title: "View Hourly  : Non-Coverage Activities Setup",
          img: require("@/assets/images/videoPageImgs/non cov fixed activities.png"),
          uTubeLink: "https://www.youtube.com/embed/4CtalWUUIq8",
        },
      ];
    }
    if(this.checkCompany.is_mcd){
      this.videoDetailsArray.push(
        {
          title: "NymbleUp Store Setting Section",
          img: require("@/assets/images/videoPageImgs/NymbleUp Store Setting Section.png"),
          uTubeLink: "https://www.youtube.com/embed/Uzd5sxWoeRM",
        }
      );
    }
    // For MCD NORTH
    // if(this.isMcdNorth){
    //   this.videoDetailsArray = [
    //     {
    //       title: "Scheduling Overview",
    //       img: require("@/assets/images/videoPageImgs/scheduling overview.png"),
    //       uTubeLink: "https://www.youtube.com/embed/f6dHHUAmQW0",
    //     },
    //     {
    //       title: "Bulk Edit Team",
    //       img: require("@/assets/images/videoPageImgs/bulk edit team.png"),
    //       uTubeLink: "https://www.youtube.com/embed/2XRYqCuRrqk",
    //     },
    //     {
    //       title: "Add Shifts Availability",
    //       img: require("@/assets/images/videoPageImgs/Shift preference.png"),
    //       uTubeLink: "https://www.youtube.com/embed/W7TFOZI8iHc",
    //     },
    //     {
    //       title: "Add New Employee",
    //       img: require("@/assets/images/videoPageImgs/add new employee.png"),
    //       uTubeLink: "https://www.youtube.com/embed/3UOxhc6T5fQ",
    //     },
    //     {
    //       title: "Store Settings Overview",
    //       img: require("@/assets/images/videoPageImgs/store setting overview.png"),
    //       uTubeLink: "https://www.youtube.com/embed/i0gSVx3K8yA",
    //     },
    //     {
    //       title: "View Hourly  : Non-Coverage Activities Setup",
    //       img: require("@/assets/images/videoPageImgs/non cov fixed activities.png"),
    //       uTubeLink: "https://www.youtube.com/embed/4CtalWUUIq8",
    //     },
    //   ];
    // }
  },
  methods: {
    handleClose() {
      console.log("handleClose");
      this.current_video = "";
    },
    startVideo(url) {
      this.videoDialogVisible = true;

      // create embed link of utube
      let updatedLink;
      // if(url.includes('https://www.youtube.com/')){
      //   updatedLink = url.replaceAll("https://www.youtube.com/watch?v=","https://www.youtube.com/embed/");
      // }else if(url.includes('https://youtu.be/')){
      //   updatedLink = url.replaceAll("https://youtu.be/","https://www.youtube.com/embed/");
      // }
      updatedLink = url + "?autoplay=1";
      this.current_video = updatedLink;
    },
  },
};
</script>
<style scoped lang="scss">
.videoPageMain {
  .login-usr {
    margin: 30px;
    margin-left: 45px;
  }
  .without-login {
    margin: 120px 70px;
  }
  .top-head {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    color: #666666;
    margin-bottom: 40px;
  }
  .video-outer-sec {
    .video-inner-sec {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .img-div {
        width: 395px;
        height: 265px;
        margin: 15px;
        background: #ffff;
        text-align: center;
        border-radius: 8px;
        box-shadow: 0 2px 10px 0 #00000033;
        border: 1px solid #d4d4d4;
        .main-img {
          width: 335px;
          margin: 15px auto;
          border: 1px solid #a8a8a8;
          border-radius: 8px;
        }
        .video-title {
          color: #828282;
          margin-top: 5px;
        }
        .play-btn-sec {
          position: relative;
          top: 20%;
          right: 50px;
          img {
            width: 100px;
            position: absolute;
            cursor: pointer;
            opacity: 0.8;
          }
          img:hover {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.videoPopup {
  .el-dialog__header {
    background: #ffffff00;
    color: #fff;
    padding: 15px;
    padding-bottom: 25px;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    background: #5e5454;
    padding: 6px;
    border-radius: 50%;
    font-weight: 800;
  }
  .el-dialog {
    background: #fff0;
    box-shadow: none;
    margin-top: 25px !important;
  }
}
</style>

